import type { FC } from "react";
import { Maximize2, Minimize2 } from "lucide-react";

type MeetingFullscreenButtonProps = {
  isFullscreen: boolean;
  onToggle: () => void;
  className?: string;
};

const MeetingFullscreenButton: FC<MeetingFullscreenButtonProps> = ({
  isFullscreen,
  onToggle,
  className = "",
}) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`flex items-center gap-1.5 rounded-full bg-gray-900/90 px-3 py-1.5 text-[11px] font-semibold text-white shadow-lg backdrop-blur-sm border border-gray-600/60 hover:bg-gray-800 ${className}`}
      aria-pressed={isFullscreen}
      aria-label={isFullscreen ? "Sair da tela cheia" : "Tela cheia"}
      title={isFullscreen ? "Sair da tela cheia" : "Tela cheia"}
    >
      {isFullscreen ? <Minimize2 className="h-3.5 w-3.5" /> : <Maximize2 className="h-3.5 w-3.5" />}
      {isFullscreen ? "Sair da tela cheia" : "Tela cheia"}
    </button>
  );
};

export default MeetingFullscreenButton;
